/** @jsxImportSource @emotion/react */
import {
  EuiBreadcrumb,
  EuiBreadcrumbs,
  EuiHeaderSection,
} from "@inscopix/ideas-eui";
import { css } from "@emotion/react";

const styles = {
  root: css`
    flex-shrink: 1;
    overflow: hidden;
    button.euiLink svg {
      color: white;
    }
  `,
  // prevent header breadcrumbs from wrapping onto multiple lines
  breadcrumbs: css`
    .euiBreadcrumbs__list {
      flex-wrap: nowrap;
    }
  `,
};

interface HeaderBreadcrumbsProps {
  breadcrumbs: EuiBreadcrumb[];
}

export const HeaderBreadcrumbs = ({ breadcrumbs }: HeaderBreadcrumbsProps) => {
  return (
    <EuiHeaderSection grow={true} css={styles.root}>
      <EuiBreadcrumbs
        breadcrumbs={breadcrumbs}
        truncate={false}
        aria-label="Breadcrumb navigation"
        responsive={{
          xs: 1,
          s: 1,
          m: 2,
          l: 3,
          xl: 4,
        }}
        css={styles.breadcrumbs}
      />
    </EuiHeaderSection>
  );
};
